<template>
  <div @submit.prevent="verify" class="step-azienda">
    <vs-row>
      <div class="flex items-end px-3 mt-4">
        <feather-icon svgClasses="w-6 h-6" icon="InfoIcon" class="mr-2 c-primary" />
        <span class="font-medium text-lg leading-none"> Dati Azienda</span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row class="mb-6">
      <vs-col class="md:w-6/12 w-full px-2">
        <label class="vs-input--label">Ragione Sociale</label>
        <vs-input class="w-full" :value="az.ragione_sociale || ' '" disabled  />
      </vs-col>
      <vs-col class="md:w-3/12 w-full px-2">
        <label class="vs-input--label">Codice fiscale</label>
        <vs-input class="w-full" :value="az.codice_fiscale || ' '" disabled  />
      </vs-col>
      <vs-col class="md:w-3/12 w-full px-2">
        <label class="vs-input--label">Partita IVA</label>
        <vs-input class="w-full" :value="az.partita_iva || ' '" disabled  />
      </vs-col>
      <!-- Sede -->
      <vs-col class="md:w-2/12 w-full px-2">
        <label class="vs-input--label">Codice Ateco</label>
        <vs-input class="w-full" :value="az.codice_attivita ? az.codice_attivita : az.attivita ?  az.attivita.codice : ' '" disabled  />
      </vs-col>
      <vs-col class="md:w-10/12 w-full px-2">
        <label class="vs-input--label">Sede Legale</label>
        <vs-input class="w-full" :value="az.indirizzo_dl ? [az.indirizzo_tipo_via_dl, az.indirizzo_dl + ',',
        az.indirizzo_numero_dl, az.capfrazione_dl || az.cap_dl, az.comune_dl + '(' + az.provincia_dl + ')' ].filter(x=>x).join(' ') : '' || ' '" disabled  />
      </vs-col>
      <!-- Legale rappresentante -->
      <vs-col class="md:w-5/12 w-full px-2">
        <label class="vs-input--label">Legale rappresentante</label>
        <vs-input :value="rap_legal(az.contatti, 0)" disabled class="w-full" />
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Luogo di nascita</label>
        <vs-input :value="rap_legal(az.contatti, 1)" disabled class="w-full" />
      </vs-col>
      <vs-col class="md:w-3/12 w-full px-2">
        <label class="vs-input--label">Data di nascita</label>
        <vs-input :value="$tariffe.formatDateNew(rap_legal(az.contatti, 2))" disabled class="w-full" />
      </vs-col>
      <!-- Contatti -->
      <vs-col class="md:w-3/12 w-full px-2">
        <label class="vs-input--label">Email</label>
        <vs-input :value="az.email_dl || ' '" disabled class="w-full" />
      </vs-col>
      <vs-col class="md:w-3/12 w-full px-2">
        <label class="vs-input--label">Telefono</label>
        <vs-input :value="az.telefono_dl || ' '" disabled class="w-full" />
      </vs-col>
      <!-- Servizio paghe -->
      <vs-col class="md:w-2/12 w-full px-2">
        <div class="vs-con-input-label">
          <vs-checkbox class="mt-8" disabled :value="az.servizi_attivi.find(x => x.codice_servizio == 'NPNP')">
            Servizio paghe
          </vs-checkbox>
        </div>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Referente paghe</label>
        <vs-input :value="az.resp_paghe ? az.resp_paghe.nome : ' '" disabled class="w-full" />
      </vs-col>
    </vs-row>
    <vs-row>
      <div class="flex items-end px-3 mt-4">
        <feather-icon svgClasses="w-6 h-6" icon="MapPinIcon" class="mr-2 c-primary" />
        <span class="font-medium text-lg leading-none">Sede Tirocinio</span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row>
      <vs-col class="md:w-6/12 w-full px-2">
        <label class="vs-input--label">Seleziona una sede per compilare automaticamente il modulo</label>
        <vs-select @input="selectSede" style="width: 100%" :disabled="is_readonly">
          <vs-select-item v-for="sede in sedi" :key="sede.id" :value="sede" :text="`${sede.tipo} - ${sede.indirizzo}`" />
        </vs-select>
      </vs-col>
      <vs-col class="md:w-6/12 w-full px-2">
        <label class="vs-input--label">Indirizzo</label>
        <vs-input disabled v-model="form.sede_indirizzo" class="w-full" />
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Comune</label>
        <vs-input disabled v-model="form.sede_comune" class="w-full" />
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Frazione</label>
        <vs-input disabled v-model="form.sede_frazione" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-2/12 w-full px-2">
        <label class="vs-input--label">CAP</label>
        <vs-input disabled v-model="form.sede_cap" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-2/12 w-full px-2">
        <label class="vs-input--label">Provincia</label>
        <vs-input disabled v-model="form.sede_provincia" class="w-full"/>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
export default {
  props: ['form','is_readonly'],
  components: {
  },

  data () {
    return {
      is_saving: false,
    }
  },

  computed: {
    az () {
      return this.form.azienda
    },
    sedi () {
      let az = this.az
      let sedi = []
      if(az['indirizzo_dc']) {
        sedi.push({
          tipo: 'Sede commerciale',
          indirizzo: [
            [az['indirizzo_tipo_via_dc'], az['indirizzo_dc']].filter(e => e).join(' '),
            az['indirizzo_numero_dc'],
          ].filter(e => e).join(', '),
          frazione: az['frazione_dc'],
          cap: az['capfrazione_dc'] || az['cap_dc'] || '',
          comune: az['comune_dc'] || '',
          provincia: az['provincia_dc'] || '',
        })
      }
      if(az['indirizzo_dl']) {
        sedi.push({
          tipo: 'Sede legale',
          indirizzo: [
            [az['indirizzo_tipo_via_dl'], az['indirizzo_dl']].filter(e => e).join(' '),
            az['indirizzo_numero_dl'],
          ].filter(e => e).join(', '),
          frazione: az['frazione_dl'],
          cap: az['capfrazione_dl'] || az['cap_dl'] || '',
          comune: az['comune_dl'] || '',
          provincia: az['provincia_dl'] || '',
        })
      }
      az.sedi.forEach( sede => {
        sedi.push({
          tipo: 'Altra sede',
          indirizzo: [
            sede['indirizzo'],
          ].filter(e => e).join(', '),
          frazione: sede['frazione'],
          cap: sede['cap'] || sede['capfrazione'] || '',
          comune: sede['comune'] || sede['frazione'] || '',
          provincia: sede['provincia'] || '',
        })
      })
      return sedi
    },
  },

  methods: {
    selectSede (sede) {
      if (!sede) sede = {}
      this.$set(this.form, 'sede_comune', (sede.comune || '') + ' ')
      this.$set(this.form, 'sede_frazione', (sede.frazione || '') + ' ')
      this.$set(this.form, 'sede_cap', (sede.cap || '') + ' ')
      this.$set(this.form, 'sede_provincia', (sede.provincia || '') + ' ')
      this.$set(this.form, 'sede_indirizzo', (sede.indirizzo || '') + ' ')
    },
    save() {
      this.is_saving = true
      this.$http.post(`modulo-tirocinio/salva?token=${this.form.token}`, this.form).then(res => {
        // if (this.form.dati_errati) return alert('Segnalazione inviata, è possibile chiudere la pagina')
        this.$parent.$parent.nextTab()
      }).finally(res => {
        this.is_saving = false
      })
    },
    rap_legal(contatti,num) {
    let leg = contatti.find( c => (c.id_ruolo == 93 || c.id_ruolo == 1))
      if (num == 0 && leg && leg.contatto) {
        return [leg.contatto.cognome,leg.contatto.nome].join(' ')
      } else if (num == 1 && leg && leg.contatto) {
        return [leg.contatto.comune_nascita,leg.contatto.provincia_nascita].join(' ')
      } else if (num == 2 && leg && leg.contatto) {
        return leg.contatto.data_nascita
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss">
.step-azienda {
  input, select {
    text-transform: uppercase!important;
  }
}
</style>
